goog.provide('el8.appshared.labVendorSplitting');

goog.require('el8.data.labVendors');

//
// labVendor specific "splitting" logic for use in both the
// laborder dlg and settings.
//
el8.appshared.labVendorSplitting = {

    quest: function(testSelected, tests) {
        // Implements Quest's test "splitting" logic i.e. the rules
        // for what combination of tests can be ordered at the same time.
        //
        // If test that is incompatible with the existing tests on the 
        // order is detected, displays an alter and returns false to
        // prevent addition
        var procedureClassSelected = testSelected.getProcedureClass();

        if (tests.length > 0) {
            // SPLITs can only be alone
            if (tests[0].item.getProcedureClass() === "SPLIT") {
                var error = "The current test must be submitted by itself.\n\nPlease use a new order for additional tests.";
                el8.uiwidget.alert(error);
                return false;
            }

            if (procedureClassSelected === 'SPLIT') {
                var error = "The selected test must be submitted on a separate order.\n\nPlease use a new order.";
                el8.uiwidget.alert(error);
                return false;
            }

            // Check whether we can add the new test by looking at the classes of the
            // already-added tests based on Quest's logic
            var has_frozen = _.chain(tests)
                              .map(function(test){ return test.item.getProcedureClass(); })
                              .map(function(pc) { return _.contains(el8.util.consts.QUEST_FROZEN_TEMP_CODES, pc); })
                              .any()
                              .value();

            if (has_frozen &&
                !_.contains(el8.util.consts.QUEST_FROZEN_TEMP_CODES, procedureClassSelected)) {
                var error = "The selected test must be submitted on a separate order due to an incompatible transport temperature (not frozen). Please use a new order.";
                el8.uiwidget.alert(error);
                return false;
            }

            var has_room_or_fridge = _.chain(tests)
                                      .map(function(test){ return test.item.getProcedureClass(); })
                                      .map(function(pc) { return _.contains(el8.util.consts.QUEST_ROOM_OR_FRIDGE_TEMP_CODES, pc); })
                                      .any()
                                      .value();

            if (has_room_or_fridge &&
                !_.contains(el8.util.consts.QUEST_ROOM_OR_FRIDGE_TEMP_CODES, procedureClassSelected)) {
                var error = "The selected test must be submitted on a separate order due to an incompatible transport temperature (not refrigerated or room temperature). Please use a new order.";
                el8.uiwidget.alert(error);
                return false;
            }
        }

        return true;
    },

    labcorp: function(testSelected, tests) {
        var procedureClassSelected = testSelected.getLabcorpProcedureClass();

        // If there are any tests at all so far, then these classes are not allowed for adding
        if (tests.length > 0) {
            if (procedureClassSelected === 'cytology' ||
                procedureClassSelected === 'histology') {
                var error = "Tests of class '" + procedureClassSelected + "' must be submitted on separate orders.  Please use a new order.";
                el8.uiwidget.alert(error);
                el8.util.amplitude.logEvent('select lab test', {'test name': testSelected._name, 'error': error});
                return false; // Don't add to list
            }
        }

        // Check whether we can add the new test by looking at class on the already-added tests
        for (var i=0; i<tests.length; i++) {
            if (tests[i].item) {
                var procedureClass = tests[i].item.getLabcorpProcedureClass();

                if (procedureClass === 'cytology' ||
                    procedureClass === 'histology') {
                    var error =  "This order already has a test of class '" + procedureClass + "'.  Please use a new order.";
                    el8.uiwidget.alert(error);
                    el8.util.amplitude.logEvent('select lab test', {'test name': testSelected._name, 'error': error});
                    return false; // Don't add to the list
                }
            }
        }

        return true;
    }
}